const YM_COUNTER_ID = 101620898;

/**
 * @param {string} goalName
 */
export function reachGoal(goalName) {
  if (typeof window === "undefined" || typeof window.ym !== "function") {
    return;
  }
  try {
    window.ym(YM_COUNTER_ID, "reachGoal", goalName);
  } catch {
    /* ignore */
  }
}
